/**
 * 対応言語
 */
export const LANG = {
  ja: 'ja',
  en: 'en',
  zhCN: 'zh-cn',
  zhTW: 'zh-tw',
  ko: 'ko',
  th: 'th'
};

/**
 * 対応言語リスト
 * @param code 識別子（APIリクエスト、レスポンスの判定で利用）
 * @param path URLパスでのみ利用
 * @param display 表示文言
 */
export const LangValues = [
  {
    code: 'ja',
    path: LANG.ja,
    display: 'JA',
    momentLang: 'ja',
    original: '日本語',
  },
  {
    code: 'en',
    path: LANG.en,
    display: 'EN',
    momentLang: 'en',
    original: 'English',
  },
  {
    code: 'zh-TW',
    path: LANG.zhTW,
    display: 'TW',
    momentLang: 'zh-tw',
    original: '中文（繁體）',
  },
  {
    code: 'zh-CN',
    path: LANG.zhCN,
    display: 'CN',
    momentLang: 'zh-cn',
    original: '中文（简体）',
  },
  {
    code: 'ko',
    path: LANG.ko,
    display: 'KO',
    momentLang: 'ko',
    original: '한국어',
  },
  {
    code: 'th',
    path: LANG.th,
    display: 'TH',
    momentLang: 'th',
    original: 'ภาษาไทย',
  }
];
